var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('div',{staticClass:"pg-loading"},[_c('img',{staticClass:"loading-img",attrs:{"src":require("./image/pg-loading.gif"),"alt":"","draggable":"false"}}),_c('span',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }